import React from 'react';
import {Link} from "react-router-dom";
import {FaChevronLeft, FaEdit} from "react-icons/fa";
import {CircularProgressbar} from "react-circular-progressbar";
import PropTypes from "prop-types";

function OutletWrapper(props) {
    const editColor = props?.editing ? 'text-warning' : ''
    const separator = props?.onEdit || props?.progress ? 'border-end' : ''

    const cpStyles = {
        text: {
            fontSize: '28px',
            fill: props?.progress && props.progress === 100 ? '#43b851' : '#3e98c7'
        },
        path: {
            stroke: props?.progress && props.progress === 100 ? '#43b851' : '#3e98c7'
        }
    }
    return (<div className="">
            <div className="d-flex justify-content-start align-items-center border-bottom">
                <Link to={props.back}>
                    <FaChevronLeft size={20} className="m-3"/>
                </Link>
                <h6 className={`my-2 border-start ${separator} px-3 flex-fill`}> {props.title}</h6>
                {
                    !!props.onEdit && (
                        <a onClick={props.onEdit}>
                            <FaEdit size={20} className={`m-3 ${editColor}`}/>
                        </a>
                    )
                }
                {
                    !!props.progress && (
                        <div className="d-inline-block my-2 mx-4 flex-shrink-0 overflow-hidden"
                             style={{width: '40px', height: '40px'}}>
                            <CircularProgressbar styles={cpStyles} strokeWidth={14} value={props.progress}
                                                 text={`${props.progress}%`}/>
                        </div>
                    )

                }
            </div>
            <div className="py-0">
                {props.children}
            </div>
        </div>
    )
}
OutletWrapper.propTypes = {
    back: PropTypes.string,
    title: PropTypes.string,
    editing: PropTypes.bool,
    //report up that edit has been clicked
    onEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    progress: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};
export default OutletWrapper;